import React from "react";

const Footer = () => {
  return (
    <>
      <div className="shane_tm_section">
        <div className="shane_tm_copyright">
          <div className="container">
            <div className="inner">
              <p>
                &copy; {new Date().getFullYear()} by{" "}
                <a
                  href="https://www.polistechnology.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Polis Technology
                </a>
                {" "}&#38;{" "}
                <a
                  href="https://www.royalrealtygroup.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Royal Realty Group
                </a>
                . All Rights Reserved
              </p>
            </div>
            {/* End inner */}
          </div>
        </div>
        {/* End shane_tm_copyright */}
      </div>
    </>
  );
};

export default Footer;
